// ギフトカード作成フロー（作成 → プレビュー/決済方法 → 確認 → 完了）の4ステップ表示ラベル
export const GIFT_CARD_FLOW_STEPS = ['作成', 'プレビュー', '確認', '完了']

// FIXME(gift_card_preview_optional): ABテスト決着後、previewOptionalの分岐が不要になったらこの定数を削除する
export const GIFT_CARD_FLOW_STEPS_PREVIEW_OPTIONAL = [
  '作成',
  '決済方法',
  '確認',
  '完了'
]
